import { Flex, Text, Box } from "@chakra-ui/react";
import React from "react";
import { SkeletonRect } from "../../../components/atoms/Skeletons";

type SettingRowBaseProps = {
  label: string;
  description?: string;
  isLoading?: boolean;
  children: React.ReactNode;
};

export function SettingRowBase({
  label,
  description,
  children,
  isLoading,
}: SettingRowBaseProps) {
  return (
    <Flex
      w="full"
      direction={{ base: "column", md: "row" }}
      gap={{ base: 4, md: 12 }}
    >
      <Box
        flexGrow={1}
        flexBasis={1}
        maxW="30em" // limit, otherwise the values get too far away from the labels.
      >
        <Text fontWeight="bold" fontSize="lg" mb={1}>
          {label}
        </Text>

        {description && (
          <Text fontSize="sm" color="gray.700">
            {description}
          </Text>
        )}
      </Box>

      <Box flexGrow={1} flexBasis={1}>
        {isLoading ?
          <SkeletonRect width="5rem">{children}</SkeletonRect>
        : children}
      </Box>
    </Flex>
  );
}
